import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import { Vue as VueIntegration } from '@sentry/integrations/dist/vue';

Sentry.init({
  enabled: process.env.NODE_ENV === 'production',
  dsn: process.env.VUE_APP_SENTRY_DSN,
  integrations: [new VueIntegration({
    Vue,
    attachProps: true,
    logErrors: process.env.NODE_ENV !== 'production', // does not show errors in console for prod
  })],
  environment: process.env.NODE_ENV,
  release: process.env.VUE_APP_SENTRY_RELEASE,
});

Sentry.setTag('server_name', process.env.VUE_APP_SENTRY_SERVER_NAME);

export default Sentry;
